import { useEffect, useState, useCallback } from "react";
import { useConfig } from "../../utensils/ConfigContext";

const useAdminClasses = () => {
  const { apiToken } = useConfig();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const filters = {
        filter_type: "AND",
        filters: [
          {
            type: "date_is",
            field: "Creado en",
            value: "America/Bogota??this_week",
          },
        ],
        groups: [],
      };

      const encodedFilters = encodeURIComponent(JSON.stringify(filters));

      const response = await fetch(
        `https://api.baserow.io/api/database/rows/table/569481/?user_field_names=true&filters=${encodedFilters}`,
        {
          headers: { Authorization: `Token ${apiToken}` },
        }
      );

      if (!response.ok) throw new Error("Error al obtener las clases");

      const data = await response.json();
      setClasses(data.results);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [apiToken]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const deleteClass = async (id) => {
    try {
      const response = await fetch(
        `https://api.baserow.io/api/database/rows/table/569481/${id}/?user_field_names=true`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Token ${apiToken}`,
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Error al eliminar clase: ${response.status} - ${errorText}`
        );
      }

      return true;
    } catch (error) {
      console.error("deleteClass error:", error.message);
      throw error;
    }
  };

  return { classes, loading, error, refetch, deleteClass };
};

// ✅ Servicio adicional para obtener una clase por ID
export const getClassById = async (classId, token) => {
  try {
    const response = await fetch(
      `https://api.baserow.io/api/database/rows/table/569481/${classId}/?user_field_names=true`,
      {
        headers: { Authorization: `Token ${token}` },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error al obtener clase: ${response.status} - ${errorText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("getClassById error:", error.message);
    throw error;
  }
};

export default useAdminClasses;
